<template lang="pug">
.precaution
  treatment-precaution-dropdown(v-if="item.editable && item.productItem.medication" :item="item" @dropdownOpenClosed="$emit('dropdownOpenClosed', $event)" @changed="$emit('changed', $event)")
  div.clickable(v-else-if="!item.editable && item.productItem.medication && item.productItem.medication.precaution")
    span.font-medium.danger500--text(v-if="item.error") {{ item.productItem.medication.precaution }}
    span(v-else) {{ item.productItem.medication.precaution }}
</template>

<script>
import TreatmentPrecautionDropdown from '@/components/clinic/consultation/treatments/treatmentTableItems/TreatmentPrecautionDropdown.vue'

export default {
  components: {
    TreatmentPrecautionDropdown,
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
</style>